@if (block().title) {
    <p class="task-list-title">{{ block().title }}</p>
}
<!-- FR-049: display only — there is deliberately no checkbox or completion control here. -->
<ol class="task-list">
    @for (task of block().tasks; track $index) {
        <li class="task">
            <span class="task-number" aria-hidden="true">{{ $index + 1 }}</span>
            <span class="task-body">
                <span class="task-label">{{ task.label }}</span>
                @if (task.action) {
                    <span class="task-action">
                        <copilot-rich-block-action-button
                            [action]="task.action"
                            (activate)="activateAction.emit($event)"
                        />
                    </span>
                }
            </span>
        </li>
    }
</ol>
